import { render, staticRenderFns } from "./CibleDetails.vue?vue&type=template&id=2be3fb32&scoped=true&"
import script from "./CibleDetails.vue?vue&type=script&lang=js&"
export * from "./CibleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3fb32",
  null
  
)

export default component.exports